import { useContext } from 'react';
import { ClientConfigContext } from 'src/contexts/ClientConfig';

const useClientConfig = () => {
  return useContext(ClientConfigContext);
};

export default useClientConfig;
